import * as React from 'react';

// API
import apibridge from '../../apibridge';

// UTILS
import { validationErrorsToString } from '../../utils';

// PACKAGES
import { useHistory, useLocation } from 'react-router';
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import LoadingSpinner from '../../components/LoadingSpinner';

// ICONS
import { ReactComponent as AlertIcon } from '../../assets/svg/alert.svg';

const ConfirmNewEmail: React.FC = () => {
	const history = useHistory();

	// Error and Loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const [isLoading, setIsLoading] = React.useState<boolean>(true);

	// Get token from query string
	const { search } = useLocation();
	const token = new URLSearchParams(search).get('token');

	const confirmToken = async () => {
		setIsLoading(true);

		const response = await apibridge.postAccountChangeEmail({ token: token || '' });

		if (response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else {
			setIsLoading(false);

			history.push('/my-account');
		}
	};

	React.useEffect(() => {
		confirmToken();
	}, []);

	return (
		<div className="confirm-email-change-page">
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<div className="confirm-error">
									<AlertIcon className="icon" />

									<p>
										An error has occurred <br />
										Please check your link and try again
									</p>
								</div>
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default ConfirmNewEmail;
